import { Button } from '@/components/ui/button';
import { whatsappLink } from '../site-config';
import { SiteContainer } from '../SiteUi';

export function SitePricing() {
  return (
    <section id="planos" className="scroll-mt-24 border-y border-[#d9d4cc] bg-white py-20 sm:py-28">
      <SiteContainer>
        <h2 className="font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          Um plano para cada momento da operação.
        </h2>

        <div className="mt-12 grid gap-4 lg:grid-cols-3">
          <article className="flex flex-col border border-[#d9d4cc] bg-[var(--site-paper)] p-8">
            <h3 className="font-display text-xl font-semibold">Essencial</h3>
            <p className="mt-2 text-sm text-[#5c5852]">Organize sua oficina</p>
            <ul className="mt-8 flex-1 space-y-2 text-sm text-[#5c5852]">
              {['OS', 'PDV', 'Estoque', 'Fiscal', 'Relatórios'].map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button asChild variant="outline" className="mt-8">
              <a href={whatsappLink('Olá! Tenho interesse no plano Essencial do AgilizaOS.')} target="_blank" rel="noopener noreferrer">
                Conversar
              </a>
            </Button>
          </article>

          <article className="relative flex flex-col border-2 border-[#f5821f] bg-white p-8 shadow-[0_16px_40px_rgba(14,26,40,0.06)]">
            <p className="text-xs font-semibold tracking-[0.18em] text-[#f5821f]">PROFISSIONAL</p>
            <h3 className="mt-2 font-display text-xl font-semibold text-[#16181d]">Faça a operação trabalhar por você</h3>
            <ul className="mt-8 flex-1 space-y-2 text-sm text-[#5c5852]">
              {['Tudo do Essencial', 'WhatsApp', 'Agendamento', 'Fidelidade', 'Campanhas'].map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button asChild variant="default" className="mt-8">
              <a href={whatsappLink('Olá! Tenho interesse no plano Profissional do AgilizaOS.')} target="_blank" rel="noopener noreferrer">
                Quero conhecer
              </a>
            </Button>
          </article>

          <article className="flex flex-col border border-[#d9d4cc] bg-[var(--site-paper)] p-8">
            <h3 className="font-display text-xl font-semibold">Rede</h3>
            <p className="mt-2 text-sm text-[#5c5852]">Controle várias unidades</p>
            <ul className="mt-8 flex-1 space-y-2 text-sm text-[#5c5852]">
              {['Tudo do Profissional', 'Multi-filial', 'Transferências', 'Gestão da matriz', 'Permissões'].map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Button asChild variant="outline" className="mt-8">
              <a href={whatsappLink('Olá! Quero uma proposta do plano Rede do AgilizaOS.')} target="_blank" rel="noopener noreferrer">
                Falar sobre minha rede
              </a>
            </Button>
          </article>
        </div>

        <p className="mt-10 max-w-[52ch] text-sm leading-relaxed text-[#5c5852]">
          O valor é definido de acordo com sua operação, número de filiais e volume.
        </p>
      </SiteContainer>
    </section>
  );
}
